import { render, staticRenderFns } from "./allEnvironments1.vue?vue&type=template&id=4242ec96&scoped=true"
import script from "./allEnvironments1.vue?vue&type=script&lang=js"
export * from "./allEnvironments1.vue?vue&type=script&lang=js"
import style0 from "./allEnvironments1.vue?vue&type=style&index=0&id=4242ec96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4242ec96",
  null
  
)

export default component.exports